export default __webpack_public_path__ + "static/media/sell-image2.f181743b.png";